/** Mobile-страница на touch-устройстве */
export const VIEWPORT_MOBILE_PAGE_CONTENT = 'width=device-width, initial-scale=1';

/** Desktop-UI на touch-устройстве (страница без mobile-вёрстки) */
export const VIEWPORT_MOBILE_DESKTOP_UI_CONTENT = 'width=1280';
